<template>
  <b-modal id="lessoninfowin" :title="lessonInfo.predm" size="lg" :ok-only="true" @ok="closeModal">
    <div v-if="localLessons && localLessons.length > 0">
      <div class="mb-3">
        <small class="text-muted">
          <span v-for="(count, type) in lessonTypeCounts" :key="type" class="mr-3">
            <strong>{{ type }}:</strong> {{ count }} <br>
          </span>
        </small>
      </div>
      
      <div v-for="(lesson, index) in localLessons" :key="lesson._id" class="lesson-comment mb-3 p-3 border rounded">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div>
            <strong>{{ formatDate(lesson.day) }}</strong>
          <br>
            <small><strong>{{ lesson.time }} {{ lesson.type.slice(0,3) }}</strong> <i>{{ lesson.groups.join(', ') }}</i></small> 
          </div>
        </div>
        <div class="form-group">
          <div v-if="!lesson.editing" class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <span v-if="lesson.log" class="comment-text">{{ lesson.log }}</span>
              <span v-else class="text-muted">Комментарий отсутствует</span>
            </div>
            <button @click="startEdit(index)" class="btn btn-sm btn-light ml-2" aria-label="Редактировать комментарий">
              ✏️
            </button>
          </div>
          <div v-else class="d-flex">
            <textarea 
              v-model="lesson.editLog" 
              class="form-control flex-grow-1"
              rows="2"
              style="margin-right: 10px;"
              placeholder="Введите комментарий..."
            ></textarea>
            <div class="ml-2 d-flex flex-column">
              <button @click="saveComment(index)" class="btn btn-sm btn-light mb-1" aria-label="Сохранить комментарий">
                💾
              </button>
              <button @click="cancelEdit(index)" class="btn btn-sm btn-light" aria-label="Отменить редактирование">
                ❌
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="text-center text-muted">
      <p>Занятия с таким названием еще не проведены. Редактирование комментариев возможно только для проведенных занятий.</p>
    </div>
  </b-modal>
</template>

<script>
const PATH = process.env.VUE_APP_PATH;

export default {
  name: 'lessonInfoWin',
  props: {
    lessonInfo: {
      type: Object,
      default: () => ({
        predm: '',
        lessons: []
      })
    }
  },
  data() {
    return {
      localLessons: [],
      lessonTypeCounts: {}
    }
  },
  watch: {
    lessonInfo: {
      handler(newVal) {
        if (newVal.lessons) {
          // Фильтруем занятия: только те, что не позднее сегодняшней даты
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Устанавливаем начало дня
          
          const filteredLessons = newVal.lessons.filter(lesson => {
            const lessonDate = new Date(lesson.day);
            lessonDate.setHours(0, 0, 0, 0);
            return lessonDate <= today;
          });
          
          this.localLessons = JSON.parse(JSON.stringify(filteredLessons));
          this.lessonTypeCounts = this.countLessonsByType(filteredLessons);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('lessoninfowin')
    },
    
    countLessonsByType(lessons) {
      const counts = {};
      lessons.forEach(lesson => {
        const type = lesson.type || 'Не указан';
        counts[type] = (counts[type] || 0) + 1;
      });
      return counts;
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('ru-RU', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    
    startEdit(index) {
      const lesson = this.localLessons[index];
      this.$set(lesson, 'editing', true);
      this.$set(lesson, 'editLog', lesson.log || '');
    },
    
    cancelEdit(index) {
      const lesson = this.localLessons[index];
      this.$set(lesson, 'editing', false);
      this.$delete(lesson, 'editLog');
    },
    
    async saveComment(index) {
      const lesson = this.localLessons[index];
      
      try {
        await this.axios.post(PATH + '/api/iss/set-log-for-lesson', {
          _id: lesson._id,
          log: lesson.editLog
        });
        
        this.$set(lesson, 'log', lesson.editLog);
        this.$set(lesson, 'editing', false);
        this.$delete(lesson, 'editLog');
        
        this.$bvModal.msgBoxOk('Комментарий успешно сохранен', {
          title: 'Подтверждение',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        });
      } catch (error) {
        console.error('Ошибка при сохранении комментария:', error);
        this.$bvModal.msgBoxOk('Ошибка при сохранении комментария', {
          title: 'Ошибка',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        });
      }
    }
  }
}
</script>

<style scoped>
.lesson-comment {
  background-color: var(--bg-muted);
  border-color: var(--border);
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--text);
}

.badge {
  font-size: 0.75em;
  color: var(--text);
}
</style>
